import { EpicValueCard } from '../EpicValueCard';
import { Carousel as CarouselUI } from '@ui-kit-ngs/molecules';
import React from 'react';
import { mapLambdaData } from '../../mappers/mapLambdaData';
import { css } from '@emotion/react';
export const Carousel = ({ cards, oddsFormat, selectionsInBetslip, navigate, maxLimit, device, deepLinkUrl, }) => {
    const isTouchable = cards.length <= 2 && device !== 'mobile'; // Hide navigation arrows for desktop single and double card view
    return (React.createElement(CarouselUI, { bilateral: true, activeElement: -1, touchable: isTouchable, customItemsStyles: css(['padding: 8px 0;'], ['cursor: auto']) }, cards.slice(0, maxLimit).map((card, index, visibleCards) => {
        const props = mapLambdaData({
            card,
            oddsFormat,
            navigate,
            selectionsInBetslip,
            index,
            deepLinkUrl,
        });
        return React.createElement(EpicValueCard, Object.assign({ key: card.selectionId }, props, { cardsCount: visibleCards.length, device: device }));
    })));
};
